import React from 'react'
import MetaHealthLogoImage from '../../../../../assets/images/MH-logo-v1 1-2.png'

const MetaHealthLogo = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '140px',
      marginBottom: '40px',
      padding: '20px 20px 40px 20px'
    }}
  >
    <img
      src={MetaHealthLogoImage}
      alt='Meta Health'
      style={{
        maxWidth: '200px',
        height: 'auto',
        opacity: 0.7,
        filter: 'grayscale(20%)'
      }}
    />
  </div>
)

export default MetaHealthLogo
